export default "__VITE_ASSET__kGDLe71p__"